import { useMemo } from 'react';

import { Capability, getCapabilities, hasAnyCapability } from '@repo/utils/auth';
import useUserGroups from './useUserGroups';

/**
 * What the reader's groups let them do, or `undefined` until the groups are known. Gate on
 * these rather than on a group, so a capability moved between roles moves every gate with it.
 */
const useCapabilities = (): Capability[] | undefined => {
  const groups = useUserGroups();
  return useMemo(() => (groups === undefined ? undefined : getCapabilities(groups)), [groups]);
};

/**
 * Whether the reader holds at least one of the capabilities. `false` until the groups are
 * known, so a control waits hidden rather than flashing up and disappearing.
 */
export const useCan = (...capabilities: Capability[]) =>
  hasAnyCapability(useCapabilities() ?? [], capabilities);

export default useCapabilities;
